<!-- 配送设置 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="top">
        <div class="box">
          <div class="title">
            满包邮设置
          </div>
          <div>
            <el-switch v-model="checkstatus"> </el-switch>
          </div>
        </div>
        <div>
          开启满包邮, 订单总金额超过多少可以包邮
        </div>
        <!-- 设置内容 -->
        <div class="inline" v-if="checkstatus">
          <div class="box2">
            <div class="left">单笔订单满:</div>
            <div class="right">
              <div style="display: flex;">
                <el-input
                  v-model="form.full_money"
                  placeholder="请输入内容"
                  size="mini"
                ></el-input>
                <div class="">元</div>
              </div>
            </div>
          </div>

          <div class="color">如果开启满额包邮，设置0为全场包邮</div>
          <!-- <div class="box2">
            <div class="left">不参加的地区:</div>
            <div class="right" >
              <div style="display: flex;">
                <el-button size="mini">选择地区</el-button>
              </div>
            </div>
          </div> -->
          <div class="box2">
            <div class="left">不参加包邮的商品:</div>
            <div class="right">
              <div v-if="commonPList.length" class="goods_line">
                <div>已选择</div>
                <div class="goods_name">{{ commonPNames }}</div>
                <div>
                  等<span>{{ commonPList.length }}</span
                  >件商品
                </div>
              </div>
              <el-button @click="checkShow" type="text">选择商品</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <el-button type="primary" @click="add">保存</el-button>
      </div>
    </div>
    <!-- 商品选择弹框 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <selectCommodity
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
      ></selectCommodity>
    </el-dialog>
  </div>
</template>

<script>
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import { getfulldetali, setfulldetali } from "@/api/fullPackage";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "merch_id", "app_id"])
  },
  components: {
    selectCommodity
  },
  data() {
    return {
      checkstatus: false,
      sList: [], //已选择的商品列表
      showSelecter: false,
      commonPId: "",
      commonPList: [],
      commonPNames: "",
      form: {
        full_money: "0",
        goods_ids: "",
        status: "0",
        id: ""
      }
    };
  },
  created() {
    this.details();
  },
  methods: {
    checkShow() {
      console.log("wobneidianji");
      this.showSelecter = true;
      this.sList = this.commonPList;
    },
    // 选择商品
    getCommod(data) {
      console.log(data);
      var ids = "",
        name = "";
      data.forEach(item => {
        ids += item.id + ",";
        name += item.name + ",";
      });
      ids = ids.substring(0, ids.length - 1);
      name = name.substring(0, name.length - 1);
      this.commonPId = ids;
      this.commonPList = data;
      this.commonPNames = name;
      this.showSelecter = false;
    },
    add() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        store_id: 0,
        merch_id: this.merch_id
      };
      data.full_money = this.form.full_money;
      data.status = this.checkstatus ? 1 : 0;
      data.goods_ids = "";
      data.id = this.form.id;
      data.goods_ids = this.commonPId;
      console.log("提交数据", data);
      // goods_ids: "",
      // status: "0"
      setfulldetali(data).then(res => {
        this.$message.success(res.msg);
      });
    },
    details() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        store_id: "0",
        merch_id: this.merch_id
      };
      getfulldetali(data).then(res => {
        console.log("详情", res);
        this.form = res.data;
        this.checkstatus = this.form.status == 1 ? true : false;
        this.commonPList = this.form.goods.data;
        this.commonPId = this.form.goods_ids;
        var listdata = [];
        this.commonPList.forEach(item => {
          listdata.push(item.name);
        });
        this.commonPNames = listdata.join(",");
        console.log("数据", listdata);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./public/style/_interfacePublic";
.content {
  /* padding: 0 48px 48px 27px; */
  .bodycontent {
    height: 100%;
    padding: 20px 40px;
    .top {
      border: 2px solid #f1f1f1;
      padding: 15px;
      .box {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .box2 {
        display: flex;
        min-height: 28px;
        margin-top: 16px;
        .left {
          width: 120px;
          text-align: right;
        }
        .right {
          margin-left: 20px;
        }
      }
      .color {
        color: #909399;
        font-size: 10px;
        padding-left: 140px;
      }
      .title {
        font-size: 14px;
        font-weight: 600;
      }
      .smalltitle {
        font-size: 12px;
        color: #595959;
        padding: 0 10px;
      }
    }

    .bottom {
      margin-top: 48px;
    }
  }
}
</style>
